import { cn } from '@/helpers/shadCnUtils';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('animate-pulse rounded-md', className)} {...props} />;
}

export { Skeleton };
